import { render } from "./AnnotationCardReply.vue?vue&type=template&id=f135741e&scoped=true"
import script from "./AnnotationCardReply.vue?vue&type=script&lang=js"
export * from "./AnnotationCardReply.vue?vue&type=script&lang=js"

import "./AnnotationCardReply.vue?vue&type=style&index=0&id=f135741e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f135741e"]])

export default __exports__